import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { iconFontVersion } from "../GlobalStyles/iconFontVersion.mjs.mjs";
import { getIconChar } from "./IconsNames.mjs.mjs";
const getPropSize = (size, property) => {
    const sizeMap = {
        small: '24px',
        xs: '16px',
        s: '24px',
        large: '48px',
        l: '48px',
    };
    return `
    ${property}: ${sizeMap[size]};
  `;
};
const getIconColor = (props) => {
    if (!props.variant) {
        return;
    }
    switch (props.variant) {
        case 'secondary':
            return props.theme.colors.ui.tertiary;
        case 'positive':
            return props.theme.colors.ui.success;
        case 'negative':
            return props.theme.colors.ui.error;
        case 'primary':
            return props.theme.colors.ui.secondary;
    }
};
const getFontClass = (props) => {
    return `${props.name}-${props.size}`;
};
export const StyledIcon = styled.div.withConfig({ displayName: "auir-41e20d9-StyledIcon", componentId: "auir-41e20d9-1ud8wbk" }) `
  display: inline-block;
`;
export const StyledIconWrapper = styled.div.withConfig({ displayName: "auir-41e20d9-StyledIconWrapper", componentId: "auir-41e20d9-r9d4jo" }) `
  ${injectSpacing('margin')};
  display: inline-block;
  ${(props) => getPropSize(props.size, 'height')}
  }
  .aui-icon-${(props) => getFontClass(props)} {
    font-family: "audi-iconfont-${iconFontVersion}";
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    text-decoration: inherit;
    ${(props) => getPropSize(props.size, 'font-size')}
  }
  .aui-icon-${(props) => getFontClass(props)}:before {
    content: ${(props) => getIconChar(props.name, props.size)};
    color: ${(props) => props.variant ? `var(${getIconColor(props)})` : 'inherit'};
    transition: color 150ms ease-in-out;
  }
`;
const getColor = (variant, props) => {
    if (!variant) {
        return;
    }
    switch (variant) {
        case 'secondary':
            return props.theme.colors.ui.tertiary;
        case 'positive':
            return props.theme.colors.ui.success;
        case 'negative':
            return props.theme.colors.ui.error;
        case 'primary':
            return props.theme.colors.ui.secondary;
    }
};
export const StyledSVG = styled.svg.withConfig({ displayName: "auir-41e20d9-StyledSVG", componentId: "auir-41e20d9-bfb9bt" }) `
  ${injectSpacing('margin')};
  color: ${(props) => props.variant ? `var(${getColor(props.variant, props)})` : 'inherit'};
  transition: color 150ms ease-in-out;
`;
//# sourceMappingURL=Icon.styles.mjs.mjs.map